"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const react_1 = __importStar(require("react"));
const utilities_1 = __importStar(require("jsAssets/utilities"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const helper_1 = require("../../helper");
const AddUserToLockedRoundModal = (props) => {
    const { open, setOpenModal, roundId } = props;
    const [lockedUsers, setLockedUser] = (0, react_1.useState)([]);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const handleSelectUser = (value) => {
        setLockedUser(value);
    };
    const handleAddUserToLockedRound = async () => {
        utilities_1.default.blockPage();
        await pulse_components_1.v2Endpoint
            .post(`${helper_1.URLS.app}api/rounds/${roundId}/add-users`, {
            reviewer_ids: lockedUsers.map((user) => user.value),
        })
            .then(({ data }) => {
            if (data) {
                const updatedRound = (0, utilities_1.camelizeKeys)(data.attributes);
                const updateNewRoundEvent = new CustomEvent('update-review-round', {
                    detail: updatedRound,
                });
                document.dispatchEvent(updateNewRoundEvent);
                utilities_1.default.notification.success('Update users success');
            }
        })
            .catch(() => {
            utilities_1.default.notification.danger('Update users failed');
        })
            .finally(() => {
            handleCloseModal();
            utilities_1.default.unblockPage();
        });
    };
    return (react_1.default.createElement(pulse_components_1.PulseModalBase, { open: open, onModalClose: handleCloseModal, headerPrimaryText: 'ADD VIEW ONLY REVIEWERS TO ROUND', PulseModalHeaderProps: {
            headerIconClasses: 'fal fa-user',
            classes: {
                root: styles_modules_less_1.default['modal-header__root'],
                titleContainer: styles_modules_less_1.default['modal-header__ctn'],
                titlePrimary: styles_modules_less_1.default['modal-header__title'],
                closeBtn: styles_modules_less_1.default['modal-header__closeBtn'],
            },
        }, classes: {
            root: [styles_modules_less_1.default['add-locked-user-modal__content']],
            dialog: {
                paper: styles_modules_less_1.default['add-locked-user-modal__root'],
            },
            footer: {
                root: [styles_modules_less_1.default['add-locked-user-modal__footer']],
            },
        }, footerCancelComponent: react_1.default.createElement(react_1.default.Fragment, null), footerConfirmDisabled: lockedUsers.length === 0, footerConfirmText: "ADD ASSIGNED USER", variant: "jqconfirm", onConfirmClick: handleAddUserToLockedRound },
        react_1.default.createElement("div", { className: styles_modules_less_1.default['locked-user-select'] },
            react_1.default.createElement("div", { className: styles_modules_less_1.default['locker-user-warning'] },
                react_1.default.createElement(pulse_components_1.PulseInfoBar, { infoType: "warning" }, "Adding a user to a locked Round will give them \u201CView Only\u201D permissions and the ability to see the names of those whom have added comments when they view the proof as an authenticated user.")),
            react_1.default.createElement(pulse_components_1.PulseProjectUsersSelect, { classes: {
                    root: styles_modules_less_1.default['locked-user-select__root'],
                    label: styles_modules_less_1.default['locked-user-select__label'],
                    select: styles_modules_less_1.default['locked-user-select__menuCtn'],
                    placeholder: styles_modules_less_1.default['locked-user-select__placeholder'],
                    selectContainer: styles_modules_less_1.default['locked-user-select__selectContainer'],
                }, labelName: 'CHOOSE ASSIGNED USER', placeholder: "Start typing to select a project team member...", insideModal: true, isClearable: false, isMulti: true, value: lockedUsers, changeHandler: (value) => {
                    handleSelectUser(value);
                }, variant: "select2" }))));
};
exports.default = AddUserToLockedRoundModal;
